import CustomerCasesPage from './CustomerCasesPage';
export default CustomerCasesPage;